import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AppConfigContext = /*#__PURE__*/createContext({
  features: {}
});
export function useAppConfig() {
  return useContext(AppConfigContext);
}
export const AppConfigConsumer = AppConfigContext.Consumer;
export const AppConfigProvider = ({
  children
}) => /*#__PURE__*/_jsx(AppConfigContext.Provider, {
  value: process.env.APP_CONFIG,
  "data-sentry-element": "unknown",
  "data-sentry-component": "AppConfigProvider",
  "data-sentry-source-file": "AppConfigContext.tsx",
  children: children
});